var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { apiGetOneClientRfp, apiUpdateClientRfpQuestion, } from '../../../../../../../actions/ClientRfpActions';
import { wrapDispatch, wrapNotifyError, } from '../../../../../../../helpers/action';
import { propArrayShape, propBool, propId, propNumber, } from '../../../../../../../helpers/custom-prop-types';
import { useUnmountRef } from '../../../../../../../helpers/use/useHook';
import QuestionContentItem from './QuestionContentItem';
const QuestionContent = (props) => {
    const { activeIndex, disabled, id, items } = props;
    const noResultText = useMemo(() => {
        if (activeIndex === 3) {
            return '回答済の質問はありません。';
        }
        if (activeIndex === 2) {
            return '未回答の質問はありません。';
        }
        return 'コンサルからの質問はありません。';
    }, [activeIndex]);
    const unmountRef = useUnmountRef();
    const onSubmit = useCallback((values, dispatch, formProps) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { isDraft } = values;
            const { changeDraftDoing, changeSaveDoing, formId } = formProps;
            try {
                if (isDraft === 0) {
                    changeSaveDoing(true);
                }
                else {
                    changeDraftDoing(true);
                }
                yield wrapDispatch(dispatch, apiUpdateClientRfpQuestion(id, formId, values));
                if (isDraft === 0) {
                    yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
                }
            }
            finally {
                if (!unmountRef.current) {
                    if (isDraft === 0) {
                        changeSaveDoing(false);
                    }
                    else {
                        changeDraftDoing(false);
                    }
                }
            }
        }));
    }), [id, unmountRef]);
    if (items.length === 0) {
        return (_jsx("div", Object.assign({ className: 'rfp_question_tab_content' }, { children: _jsx("p", Object.assign({ className: 'no_result' }, { children: noResultText })) })));
    }
    return (_jsx("div", Object.assign({ className: 'rfp_question_tab_content' }, { children: items.map((item) => (_jsx(QuestionContentItem, { disabled: disabled, item: item, onSubmit: onSubmit }, item.id))) })));
};
QuestionContent.propTypes = {
    activeIndex: propNumber().isRequired,
    disabled: propBool().isRequired,
    id: propId().isRequired,
    items: propArrayShape().isRequired,
};
export default QuestionContent;
